import { render, staticRenderFns } from "./officialAccKeyword.vue?vue&type=template&id=37559e6e&scoped=true&"
import script from "./officialAccKeyword.vue?vue&type=script&lang=js&"
export * from "./officialAccKeyword.vue?vue&type=script&lang=js&"
import style0 from "./officialAccKeyword.vue?vue&type=style&index=0&id=37559e6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37559e6e",
  null
  
)

component.options.__file = "officialAccKeyword.vue"
export default component.exports